import {IHaveRules, ISurvey} from 'app/interfaces/ISurvey'
import { ISurveyDef } from 'app/interfaces/ISurveyDef'
import { SurveyPropertiesValidationError } from 'app/custom-errors/SurveyPropertiesValidationError'

export class SurveyPropertyValidator implements ISurvey {

  id: string
  projectId: number
  surveyDef: ISurveyDef
  title: Record<string, string>
  haveRules: IHaveRules

  constructor(survey: ISurvey) {
    this.id = survey.id
    this.projectId = survey.projectId
    this.surveyDef = survey.surveyDef
    this.title = survey.title
  }

  validate() {

    const requiredProperties = Object.getOwnPropertyNames(this)
    let missingProperties: string[] = []
    for (const idx in requiredProperties) {
      if (this[requiredProperties[idx]] === undefined || this[requiredProperties[idx]] === null) {
        missingProperties.push(requiredProperties[idx])
      }
    }

    if (missingProperties.length) {
      throw new SurveyPropertiesValidationError().missingProperties(missingProperties, this)
    }

  }
}
